/* Horizontal Tab Structure */
jQuery('.tab-link').click( function() {
  var tabID = jQuery(this).attr('data-tab');
  jQuery(this).addClass('active').siblings().removeClass('active');
  jQuery(".accordion-item").removeClass('active');
  jQuery('.accordion-item.'+tabID).addClass('active');
});

$(document).ready(function(){
  $(".slick-track").find(".slick-current").next().next().addClass("focus-slide");
  
  /*Fix instafeed app section layout similiar to design*/
  $("#shopify-section-template--23658075488578__17326285075123a054").removeClass("section");
  
  var tabID = jQuery('.tab-link').attr('data-tab');
  $(".accordion-item." + tabID).addClass("active");

  /*Newsletter Input field label customization*/
  $('#ContactFooter .field__input')
    .focus(function() {
      $(this).next('.field__label').addClass('hide');
    })
    .blur(function() {
      if ($(this).val().trim() === '') {
        $(this).next('.field__label').removeClass('hide');
      } else {
        $(this).next('.field__label').addClass('hide');
      }
  });

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        //clearHeader, not clearheader - caps H
        $(".header-wrapper ").addClass("darkHeader");
    } else {
        // Remove class when scrolled back to the top
        $(".header-wrapper").removeClass("darkHeader");
    }
});
  
});

/* Vertical Tab Structure */
$('.tabs-nav ul li').hover(function() {
    $('.triangle-container').remove();
    show_content($(this).index());
});
$('.tabs-nav ul li').on('click', function() {
    $('.triangle-container').remove();
    show_content($(this).index());
});
  
show_content(0);
function show_content(index) {
    // Make the content visible
    $('.tabs .content.visible').removeClass('visible');
    $('.tabs .content:nth-of-type(' + (index + 1) + ')').addClass('visible');

    // Set the tab to selected
    $('.tabs-nav ul li.selected').removeClass('selected');
    $('.tabs-nav ul li:nth-of-type(' + (index + 1) + ')').addClass('selected');
}

/*Accordian*/
const accordionItemHeaders = document.querySelectorAll(
  '.accordion-item-header'
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener('click', (event) => {
    accordionItemHeader.classList.toggle('active');
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains('active')) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + 'px';
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});

/*Review Slider*/
$('.testimonial-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    asNavFor: '.testimonial-nav',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: true,
            }
        }
    ]
});
$('.testimonial-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.testimonial-slider',
    dots: false,
    arrows: false,
    fade: true,
    centerMode: false,
    focusOnSelect: true
});

$('.testimonial-nav').on('afterChange', function(event, slick, currentSlide){
    //alert('Slide changed!');

    // Remove custom class from all slides
    $('.slick-slide').removeClass('focus-slide');

    // Calculate the index of the next slide
    var nextSlideIndex = (currentSlide + 1) % slick.slideCount; // Loop back to the first slide when reaching the end
    
    // Add the custom class to the next slide
    $('.slick-track .slick-slide').eq(nextSlideIndex + 2).addClass('focus-slide');

    console.log('Current slide index:', currentSlide);
    console.log('Next slide index:', nextSlideIndex);
    $(".slick-track").find(".slick-slide").removeClass("focus-slide");
    $(".slick-track").find(".slick-current").next().next().addClass("focus-slide");
    if(nextSlideIndex == 0){
      console.log('Index 0');
      //$(this).find(".slick-track").children(":first").addClass("focus-slide");
      $(this).find(".slick-track").children().eq(1).addClass("focus-slide");
    }
    if(nextSlideIndex == 3){
      $(this).find(".slick-track").children().eq(0).addClass("focus-slide");
    }
});


/*Multi-column Grid Carousel Slider*/
$('.gloci-skin').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  speed: 500,
  fade: false,
  cssEase: 'linear',
  autoplay: true,
  arrows: false,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        variableWidth: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        arrows: false,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        variableWidth: true,
        arrows: true,
      },
    },
  ],
});